(()=>{
  const getProduct=async productUrl=>{
    const url=new URL(productUrl,window.location.origin);
    const response=await fetch(url.pathname.replace(/\/$/,'')+'.js',{headers:{Accept:'application/json'}});
    if(!response.ok)throw new Error('product fetch failed');
    return response.json();
  };

  const addVariant=async variantId=>{
    const response=await fetch('/cart/add.js',{
      method:'POST',
      headers:{'Content-Type':'application/json',Accept:'application/json'},
      body:JSON.stringify({items:[{id:variantId,quantity:1}]})
    });
    if(!response.ok)throw new Error('cart add failed');
    return response.json();
  };

  const refreshCartCount=async()=>{
    try{
      const response=await fetch('/cart.js',{headers:{Accept:'application/json'}});
      if(!response.ok)return;
      const cart=await response.json();
      document.querySelectorAll('.ak-actions a[href*="/cart"]').forEach(link=>{
        link.textContent=`Cart (${cart.item_count})`;
      });
    }catch{}
  };

  const wireBuyNow=button=>{
    if(button.dataset.akBuyReady==='true')return;
    const productUrl=button.getAttribute('href');
    if(!productUrl)return;
    button.dataset.akBuyReady='true';
    button.textContent='BUY NOW';
    button.classList.add('ak-home-buy-now');
    button.addEventListener('click',async event=>{
      if(button.getAttribute('aria-busy')==='true')return;
      event.preventDefault();
      button.setAttribute('aria-busy','true');
      const previous=button.textContent;
      button.textContent='LOADING…';
      try{
        const product=await getProduct(productUrl);
        const variants=product.variants||[];
        const available=variants.filter(variant=>variant.available);
        if(variants.length===1&&available.length===1){
          await addVariant(available[0].id);
          window.location.assign('/checkout');
          return;
        }
        window.location.assign(productUrl);
      }catch{
        window.location.assign(productUrl);
      }finally{
        button.removeAttribute('aria-busy');
        button.textContent=previous;
      }
    });
  };

  const AMAZON_URL='https://www.amazon.com/s?me=AVAZFZ3DL516M&marketplaceID=ATVPDKIKX0DER';

  const wireAmazon=actions=>{
    if(!actions)return;

    const existingButtons=[...actions.querySelectorAll(':scope > .ak-inventory-amazon')];
    const existingNotes=[...actions.querySelectorAll(':scope > .ak-inventory-amazon-note')];
    existingButtons.slice(1).forEach(el=>el.remove());
    existingNotes.slice(1).forEach(el=>el.remove());

    let amazon=existingButtons[0]||null;
    let note=existingNotes[0]||null;

    if(!amazon){
      amazon=document.createElement('a');
      amazon.className='ak-inventory-amazon';
      amazon.href=AMAZON_URL;
      amazon.setAttribute('aria-label','New on Amazon — click here to buy now and get a free gift');
      amazon.innerHTML=`
        <span class="ak-inventory-amazon__brand" aria-hidden="true">
          <span class="ak-inventory-amazon__word">amazon</span>
          <svg class="ak-inventory-amazon__smile" viewBox="0 0 70 16" role="presentation" focusable="false">
            <path d="M4 4c16 10 38 11 61 1" fill="none" stroke="currentColor" stroke-width="3.4" stroke-linecap="round"/>
            <path d="M59 2l7 3-4 6" fill="none" stroke="currentColor" stroke-width="2.8" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </span>
        <span class="ak-inventory-amazon__copy">
          <span class="ak-inventory-amazon__eyebrow">NEW ON AMAZON</span>
          <span class="ak-inventory-amazon__line">CLICK HERE TO BUY NOW <span>+ GET A FREE GIFT</span></span>
        </span>
        <span class="ak-inventory-amazon__recommend" aria-hidden="true">
          <span class="ak-inventory-amazon__recommend-text">HIGHLY<br>RECOMMENDED</span>
          <span class="ak-inventory-amazon__fire">🔥</span>
        </span>`;
    }else{
      amazon.href=AMAZON_URL;
      const recommendText=amazon.querySelector('.ak-inventory-amazon__recommend-text');
      if(recommendText)recommendText.innerHTML='HIGHLY<br>RECOMMENDED';
    }

    if(!note){
      note=document.createElement('div');
      note.className='ak-inventory-amazon-note';
      note.setAttribute('role','note');
      note.setAttribute('aria-label','At Amazon checkout, click gift option. Type free gift for a free gift, or type free jerky for a free jerky bag.');
      note.innerHTML=`
        <span>AT AMAZON CHECKOUT: CLICK GIFT OPTION</span>
        <span>TYPE <b>“FREE GIFT”</b> FOR A FREE GIFT</span>
        <span>OR TYPE <b>“FREE JERKY”</b> FOR A FREE JERKY BAG</span>`;
    }

    const details=actions.querySelector(':scope > .ak-home-details');
    if(details){
      if(details.nextElementSibling!==amazon)details.insertAdjacentElement('afterend',amazon);
      if(amazon.nextElementSibling!==note)amazon.insertAdjacentElement('afterend',note);
    }else{
      if(!amazon.parentElement)actions.appendChild(amazon);
      if(!note.parentElement)actions.appendChild(note);
    }
  };

  const wireAddToCart=actions=>{
    if(actions.querySelector('.ak-home-add-to-cart'))return;
    const buy=actions.querySelector('.ak-home-buy-now,.ak-btn--red[href*="/products/"]');
    const details=actions.querySelector('.ak-home-details[href*="/products/"],.ak-btn--ghost[href*="/products/"],a[href*="/products/"]:last-child');
    const productUrl=(buy||details)?.getAttribute('href');
    if(!productUrl)return;

    const button=document.createElement('button');
    button.type='button';
    button.className='ak-btn ak-home-add-to-cart';
    button.textContent='ADD TO CART';
    button.setAttribute('aria-label','Add this jerky to cart');

    if(details&&details.parentElement===actions)actions.insertBefore(button,details);
    else actions.appendChild(button);

    button.addEventListener('click',async()=>{
      if(button.getAttribute('aria-busy')==='true')return;
      button.setAttribute('aria-busy','true');
      button.textContent='ADDING…';
      try{
        const product=await getProduct(productUrl);
        const variants=product.variants||[];
        const available=variants.filter(variant=>variant.available);
        if(variants.length!==1||available.length!==1){
          window.location.assign(productUrl);
          return;
        }
        await addVariant(available[0].id);
        await refreshCartCount();
        button.textContent='ADDED TO CART';
        setTimeout(()=>{
          button.textContent='ADD TO CART';
          button.removeAttribute('aria-busy');
        },1400);
      }catch{
        button.textContent='ADD TO CART';
        button.removeAttribute('aria-busy');
        window.location.assign(productUrl);
      }
    });
  };

  const init=()=>{
    const home=document.querySelector('.ak-home');
    if(!home)return;

    home.querySelectorAll('.ak-hero-tap-hint').forEach(hint=>hint.remove());
    home.querySelectorAll('.ak-inventory-rail__head h3').forEach(heading=>{
      if(/^view all beef jerkies$/i.test(heading.textContent.trim()))heading.textContent='VIEW ALL BEEF JERKY';
    });
    home.querySelectorAll('.ak-hero-detail .ak-home-details,.ak-switcher-info .ak-home-details,.ak-inventory-card .ak-btn--ghost').forEach(link=>{
      link.textContent='VIEW PRODUCT DETAILS';
      link.classList.add('ak-home-details');
    });

    const buyButtons=[...home.querySelectorAll('.ak-hero-detail .ak-btn--red,.ak-switcher-info .ak-btn--red,.ak-inventory-card .ak-btn--red')];
    buyButtons.forEach(wireBuyNow);

    const actionSelector='.ak-hero-detail .ak-home-product-actions,.ak-switcher-info .ak-home-product-actions,.ak-inventory-card .ak-inventory-card__actions';
    home.querySelectorAll(actionSelector).forEach(actions=>{
      wireAddToCart(actions);
      wireAmazon(actions);
    });

    if(!home.dataset.akAmazonObserverReady&&'MutationObserver' in window){
      home.dataset.akAmazonObserverReady='true';
      let queued=false;
      const observer=new MutationObserver(()=>{
        if(queued)return;
        queued=true;
        requestAnimationFrame(()=>{
          queued=false;
          home.querySelectorAll(actionSelector).forEach(actions=>{
            wireAddToCart(actions);
            wireAmazon(actions);
          });
        });
      });
      observer.observe(home,{childList:true,subtree:true});
    }

    const primary=home.querySelector('.ak-copy .ak-btn--red');
    if(primary&&/^shop jerky$/i.test(primary.textContent.trim()))primary.textContent='BUY JERKY';
  };

  document.addEventListener('DOMContentLoaded',init);
  document.addEventListener('shopify:section:load',init);
  window.addEventListener('pageshow',init);
})();